export const MY_LIST_FILTER_KEY = 'is_my_list'
export const EXHIBITOR_FILTER_KEY = 'exhibited_only'
export const SHARED_FROM_KEY = 'shared_from'
